import {connect} from 'react-redux'
import PhonereloadEzBillView from '../components/PhonereloadEzBillView'

import {changeStep} from "../../../../layouts/Content/modules/step";
import {submitTransaction} from '../modules/ezbill'
import {appSetVal, appSetServerVal, appSetObj, appCall, checkFields} from '../../../../store/application'
import {C} from "../../../../helpers";


const mapDispatchToProps = {
  appCall: appCall,
  appSetServerVal: appSetServerVal,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  changeStep: changeStep,
  checkFields: checkFields,

  submitTransaction: submitTransaction
};

const mapStateToProps = (state) => {
  const {ready_to_submit, account, phone_number_validation, required_PIN, display_amount} = state.app.x_data;

  const {customer_id, phone_number} = state.customer;

  const {icon, title, require_pin, product_denom_mapping, product_denom_type} = state.app.product_data;
  const {} = state.app.product_data;

  const denominations = product_denom_mapping && product_denom_type 
    ? _.map(product_denom_mapping, (v, k) => ({key: k, text: C(v[0], '$'), amount: v[0], value: k}))
    : null;

  return {
    icon,
    title,
    customer_id,
    ready_to_submit: !ready_to_submit,
    phone_number,
    account,
    phone_error_type: phone_number_validation && phone_number_validation.type,
    display_amount,
    require_pin,
    required_PIN,
    denominations,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PhonereloadEzBillView)


// WEBPACK FOOTER //
// ./src/components/Applications/PhonereloadEzBill/containers/PhonereloadEzBillContainer.js